import { useEffect, useRef, useState } from 'react';
import { useReducedMotion } from './useReducedMotion';

export const EXAMPLE_PROMPTS = [
  'Vela, help me get more customers.',
  'Vela, launch my next campaign.',
  'Vela, create this week’s social posts.',
];
const TYPE_MS = 42;
const HOLD_MS = 2800;
const FADE_MS = 380;

// Illustrative prompts only — typed one at a time, held, then softly swapped. Reduced motion → one static example.
export function TryAskingVela({ className = '' }) {
  const reduce = useReducedMotion();
  const [idx, setIdx] = useState(0);
  const [shown, setShown] = useState(reduce ? EXAMPLE_PROMPTS[0] : '');
  const [fading, setFading] = useState(false);
  const timer = useRef(null);

  useEffect(() => {
    if (reduce) { setShown(EXAMPLE_PROMPTS[0]); setFading(false); return undefined; }
    const full = EXAMPLE_PROMPTS[idx];
    let n = 0;
    setFading(false);
    setShown('');
    const tick = () => {
      n += 1;
      setShown(full.slice(0, n));
      if (n < full.length) { timer.current = setTimeout(tick, TYPE_MS); return; }
      timer.current = setTimeout(() => {
        setFading(true);
        timer.current = setTimeout(() => setIdx((i) => (i + 1) % EXAMPLE_PROMPTS.length), FADE_MS);
      }, HOLD_MS);
    };
    timer.current = setTimeout(tick, 500);
    return () => clearTimeout(timer.current);
  }, [idx, reduce]);

  const typing = !reduce && shown.length < EXAMPLE_PROMPTS[idx].length;
  return (
    <div className={className} data-testid="meet-vela-try-asking" aria-label="Example requests you can ask Vela">
      <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-white/40 mb-2.5">Try asking Vela</p>
      <div className="relative inline-flex w-full max-w-md">
        <div className="relative w-full rounded-2xl rounded-bl-md border border-white/10 bg-white/[0.04] backdrop-blur-md px-4 py-3.5 min-h-[3.5rem] flex items-center shadow-[inset_0_1px_0_rgba(255,255,255,0.04)]">
          <span className="absolute -left-px bottom-0 h-3 w-3 rounded-br-2xl border-b border-l border-white/10 bg-[#07070b]" aria-hidden="true" style={{ transform: 'translate(-45%, 45%) rotate(45deg)' }} />
          <p aria-live="off" data-testid="meet-vela-example-prompt"
            className="text-[15px] sm:text-base text-white/85 font-medium leading-snug transition-opacity ease-out"
            style={{ opacity: fading ? 0 : 1, transitionDuration: `${FADE_MS}ms` }}>
            {shown}
            {!reduce && <span className={`inline-block w-[2px] h-[1.05em] align-[-0.18em] ml-0.5 rounded-sm bg-fuchsia-300 ${typing ? '' : 'mv-caret'}`} aria-hidden="true" />}
          </p>
        </div>
      </div>
    </div>
  );
}
